import {list} from "custom/demo/requests/admin/organizations";
import AdminList from "custom/demo/helpers/admin/list";

const actions = {edit: true, list, new: true};

const columns = [
  {key: "name", label: "Name"},
  {key: "subdomain", label: "Subdomain"},
  {key: "logo", label: "Logo", render: (record) => (record.logo ? <img alt="Logo" src={record.logo} width={150} /> : "None")},
  {key: "deck_name", label: "Deck"},
  {key: "show_notice", label: "Show Notice"},
  {key: "show_stats", label: "Show Stats"}
];

export default function List() {
  return <AdminList actions={actions} columns={columns} name="Organization" path="/admin/organizations" />;
}
